(() => {
  if (window.__ppCartUXLoaded) return;
  window.__ppCartUXLoaded = true;

  let previousTotal = null;
  let toastTimer = null;

  const getTracker = () => document.querySelector('.rewards-tracker[data-pp-cart-total]');

  const hideChatHost = (hide) => {
    const selectors = [
      '#ShopifyChat',
      'inbox-online-store-chat',
      'shopify-chat',
      'iframe[title*="chat" i]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      if (hide) {
        if (!el.dataset.ppPrevDisplay) el.dataset.ppPrevDisplay = el.style.display || '__empty__';
        el.style.setProperty('display', 'none', 'important');
      } else if (el.dataset.ppPrevDisplay) {
        const prev = el.dataset.ppPrevDisplay;
        if (prev === '__empty__') el.style.removeProperty('display');
        else el.style.setProperty('display', prev);
        delete el.dataset.ppPrevDisplay;
      }
    });
  };

  const syncChat = () => {
    const open = !!document.querySelector('cart-drawer.active');
    document.body.classList.toggle('pp-cart-drawer-open', open);
    hideChatHost(open);
  };

  const showToast = (message, type = 'generic', imageUrl = '') => {
    if (!message) return;
    let toast = document.getElementById('PPRewardToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'PPRewardToast';
      toast.className = 'pp-reward-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.className = 'pp-reward-toast pp-reward-toast--' + type;

    let visual = '';
    if (type === 'nuri' && imageUrl) {
      visual = '<span class="pp-reward-toast__visual pp-reward-toast__visual--image"><img src="' + imageUrl + '" alt="NURI Sardines in Olive Oil"></span>';
    } else if (type === 'pickup') {
      visual = '<span class="pp-reward-toast__visual" aria-hidden="true">📦</span>';
    } else if (type === 'home') {
      visual = '<span class="pp-reward-toast__visual" aria-hidden="true">🏠🚚</span>';
    } else {
      visual = '<span class="pp-reward-toast__visual" aria-hidden="true">🎉</span>';
    }

    toast.innerHTML = visual + '<span class="pp-reward-toast__copy"><strong>' + message + '</strong></span>';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  const checkRewards = (initial = false) => {
    const tracker = getTracker();
    if (!tracker) return;

    const total = Number(tracker.dataset.ppCartTotal || 0);
    const mode = tracker.dataset.ppRewardMode || 'baltic';
    const pickup = Number(tracker.dataset.ppPickupThreshold || 5000);
    const nuri = Number(tracker.dataset.ppNuriThreshold || 8000);
    const home = Number(tracker.dataset.ppHomeThreshold || 10000);

    if (previousTotal === null || initial) {
      previousTotal = total;
      return;
    }

    if (total > previousTotal) {
      let message = '';
      if (mode === 'gift-only') {
        if (previousTotal < nuri && total >= nuri) {
          message = tracker.dataset.ppNuriToast;
          if (message) showToast(message, 'nuri', tracker.dataset.ppNuriImage || '');
        }
      } else {
        if (previousTotal < home && total >= home) {
          message = tracker.dataset.ppHomeToast;
          if (message) showToast(message, 'home');
        } else if (previousTotal < nuri && total >= nuri) {
          message = tracker.dataset.ppNuriToast;
          if (message) showToast(message, 'nuri', tracker.dataset.ppNuriImage || '');
        } else if (previousTotal < pickup && total >= pickup) {
          message = tracker.dataset.ppPickupToast;
          if (message) showToast(message, 'pickup');
        }
      }
    }
    previousTotal = total;
  };

  const syncAll = () => {
    syncChat();
    checkRewards(false);
  };

  const init = () => {
    syncChat();
    checkRewards(true);

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(syncAll);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();